import { Services } from '@sigma-frontend-libs/commons'
import { DOCUMENT_TEMPLATES_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, services } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import DocumentTemplatesSelector from '@/components/services/documentTemplates/selector'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${services.companies}.labels.title`),
        dense: true,
        required: true,
        clearable: true,
        autofocus: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}
function renderVatSwitch(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.vat,
        label: this.getTranslate(`${services.companies}.titles.vat`),
        outline: true
      },
      on: {
        input: event => {
          this.proxy.vat = event
        }
      }
    }
  )
}
function renderBaseFields(h) {
  return h(
    'div',
    {
      class: `${Services.companies}-form-row`
    },
    [
      renderTitleField.call(this, h),
      renderVatSwitch.call(this, h)
    ]
  )
}

function renderDocumentButtons(h) {
  if (this.proxy.id) {
    return h(
      'div',
      {
        class: `${Services.companies}-form-documents`
      },
      DOCUMENT_TEMPLATES_TYPES.map(type => {
        return h(
          DocumentTemplatesSelector,
          {
            props: {
              CompanyId: this.proxy.id,
              type
            }
          }
        )
      })
    )
  }
}

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        dense: true,
        required: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.companies}-form`]: true,
        [`${Services.companies}-form--new`]: this.isNew
      }
    },
    [
      renderBaseFields.call(this, h),
      renderDocumentButtons.call(this, h),
      renderSelectorOwner.call(this, h)
    ]
  )
}
